import React from 'react';
import RolloverList from '../components/rollover/RolloverList';

const Rollover = () => {
  return <RolloverList />;
};

export default Rollover;